import auth from "./auth";
import { CustomList } from "./mixin/elList";
import store from "@/store";
// import { CustomForm } from "./elForm";
let sm2 = require("sm-crypto").sm2;
import { Message } from "element-ui";
const Base64 = require("js-base64").Base64;

const utils = {
  /* ----------时间转换 Begin---------- */
  /**
   * @param {*} fmtDate 日期
   * @param {*} fmt 转换格式，如（年月日：yyyy-MM-dd hh:mm:ss）
   * @returns
   */
  formatDatetime(fmtDate, fmt) {
    if (!fmtDate) {
      return "";
    }
    let date = "";
    if (this.isValidDate(new Date(fmtDate))) {
      date = new Date(fmtDate);
    } else if (this.isValidDate(new Date(fmtDate.replace(/-/g, "/")))) {
      date = new Date(fmtDate.replace(/-/g, "/"));
    } else if (fmtDate && typeof fmtDate === "string") {
      date = new Date(fmtDate.replace(/\+[\d]{4}/, ""));
    } else {
      return "";
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }

    let obj = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let key in obj) {
      if (new RegExp(`(${key})`).test(fmt)) {
        let str = obj[key] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  },
  isValidDate(date) {
    return date instanceof Date && date.getTime();
  },
  padLeftZero(str) {
    return ("00" + str).substr(str.length);
  },
  /**
   * 计算文件大小
   * @param {*} size 文件大小
   * @param {*} type 尺寸类型 byte：字节,bit
   * @returns
   */
  getSize(size, type = "bit") {
    let data = 1;
    let unit = "KB";
    let multiple = type != "bit" ? 1 : 1024;

    if (size >= 1024 * 1024 * multiple) {
      data = 1024 * 1024 * multiple;
      unit = "G";
    } else if (size >= 1024 * multiple) {
      data = 1024 * multiple;
      unit = "M";
    } else {
      data = 1024;
    }
    let num = parseInt(size) ? parseInt(size) / data : 0;
    if (parseInt(num) == num) {
      return num + unit;
    } else {
      return num.toFixed(1) + unit;
    }
  },
  /* ----------字典数据查询 Begin---------- */
  /**
   *
   * @param {String,Array} value value值，支持字符串和数组
   * @param {Array} list 字典数组
   * @param {String} joinSymbol 字典数组
   * @returns
   */
  getDicName(value, list, joinSymbol = ",") {
    let name = [];
    let valueInfo = [];

    if (typeof value === "string") {
      valueInfo = value.split(",") || [];
    } else if (value instanceof Array) {
      valueInfo = value;
    } else {
      valueInfo = [value];
    }
    if (list && list instanceof Array) {
      list.forEach((el) => {
        if (
          valueInfo.includes(el.value.toString()) ||
          valueInfo.includes(Number(el.value))
        ) {
          name.push(el.label);
        }
      });
    }
    return name.join(joinSymbol);
  },
  /**
   * 用户获取处理后的formData对象，传入参数依次为
   * form：表单元素对象，
   * keys：文件类字段的集合，
   * fileNames：上传给后台文件命名（顺序需与keys保持一致）
   */
  getFormData(form, keys, fileNames) {
    let formData = new FormData();
    keys.forEach((key, index) => {
      if (typeof form[key] !== "string") {
        formData.append(fileNames[index], form[key]);
      } else {
        formData.append(key, form[key]);
      }
    });
    for (let i in form) {
      if (!keys.includes(i) && form[i] !== null) {
        formData.append(i, form[i]);
      }
    }
    return formData;
  },
  /**
   * form表单数据处理,避免新数据与form表单字段不一致
   * @param {*} form form表单
   * @param {*} ob
   */
  formInfoGet(form, data, except = []) {
    if (!data) return {};
    except = except.concat([
      "createdTime",
      "updatedTime",
      "created_time",
      "updated_time",
      "udpatedTime",
    ]);
    except = Array.from(new Set(except));
    let new_data = {};
    for (const key in data) {
      if (!except.includes(key)) {
        new_data[key] = data[key];
      }
    }
    return { ...form, ...new_data };
  },
  /**
   * 根据数组对象的某个字段去重
   * item.name  是[{name:1}] 根据每条数据的name值来去重
   * */
  unique(arr, val) {
    const res = new Map();
    return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
  },
  /**弹窗配置*/
  dialogParams() {
    return {
      textMap: {
        // 弹窗标题
        add: "新增",
        edit: "编辑",
        view: "查看",
      },
      dialogProps: {
        //弹窗配置
        "close-on-click-modal": false,
        class: "ly-c-dialog",
        width: "600px",
      },
    };
  },
  /**表单配置*/
  formProps() {
    return {
      // "label-position": "left",
      "label-width": "auto",
      class: "ly-c-form",
      size: "small",
    };
  },
  /**
   * form表单去除空格
   * @param ruleForm form表单
   * @param except 数组 不需要去除空格的数据集合
   */
  formTrim(ruleForm, except = []) {
    except = except.concat([
      "remark",
      "createdTime",
      "updatedTime",
      "created_time",
      "updated_time",
    ]);
    except = Array.from(new Set(except));
    for (const key in ruleForm) {
      if (typeof ruleForm[key] === "string" && !except.includes(key)) {
        ruleForm[key] = ruleForm[key].replace(/\s+/g, "");
      }
    }
  },
  /*·----------表单数据处理·End----------·*/
  /**sm2加密
   * @param {*} msgString 加密字符串
   */
  doEncrypt(msgString) {
    if (msgString) {
      let msg = msgString;
      // 1 - C1C3C2；	0 - C1C2C3；	默认为1
      let cipherMode = 1;
      let publicKey =
        "04699048AF516A173CDB847FDE7E410D0C1BB41CD1752618E420194D77E6917EA1A478F600CD60C82305265F68F21ABEC4658D36E00F364D933EAB81C61FBD3963";
      let encryptData = sm2.doEncrypt(msg, publicKey, cipherMode);
      // 加密后的密文前需要添加04，后端才能正常解密
      let encrypt = "04" + encryptData;
      return encrypt;
    } else {
      return "";
    }
  },
  doDecrypt(msgString) {
    if (msgString) {
      let msg = msgString.substr(2);
      // 1 - C1C3C2；     0 - C1C2C3；     默认为1
      let cipherMode = 1;
      let privateKey =
        "00F7B61B57C07ECCDA506E6EE5A484777A179BA6A147B1906FC61D4D36D212DC03";
      return sm2.doDecrypt(msg, privateKey, cipherMode);
    } else {
      return "";
    }
  },

  /*·----------按钮权限校验·Begin----------·*/
  /*·----------关闭浏览器窗口·Begin----------·*/
  windowClose() {
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("MSIE") > 0) {
      if (userAgent.indexOf("MSIE 6.0") > 0) {
        window.opener = null;
        window.close();
      } else {
        window.open("", "_top");
        window.top.close();
      }
    } else if (
      userAgent.indexOf("Firefox") != -1 ||
      userAgent.indexOf("Chrome") != -1
    ) {
      window.location.href = "about:blank "; //火狐默认状态非window.open的页面window.close是无效的
      window.close();
    } else {
      window.opener = null;
      window.open("about:blank", "_self");
      window.close();
    }
  },
  /*·----------关闭浏览器窗口·End----------·*/
  // 按钮是否有权限
  isAuth(key) {
    let userInfo = auth.getUserInfo();
    const permissions = this.getStore("btnPermissions") || [];
    // if(userInfo&&userInfo.userUuid=='superadmin'){
    //   return true;
    // }else{
    return permissions.includes(key);
    // }
  },
  getStore(param) {
    if (store.getters) {
      return store.getters[param];
    } else {
      return null;
    }
  },
  // 判断操作栏是否无按钮控制显示隐藏
  isHasBtn(keys) {
    const permissions = this.getStore("btnPermissions") || [];
    let hasBtn = false;
    if (keys.length > 0) {
      keys.forEach((key) => {
        if (permissions.includes(key)) hasBtn = true;
      });
    } else {
      hasBtn = true;
    }

    return hasBtn;
  },

  /*·----------校验列表数据是否最后一条，删除页数减一查询·End----------·*/
  isLastData(pages, listLength, delLength) {
    if (pages.pageNum === 1) return;
    const pageTotal = Math.ceil(pages.total / pages.pageSize);
    if (pageTotal !== pages.pageNum || listLength !== delLength) return;
    pages.pageNum = pages.pageNum - 1;
  },

  // 设置表格多选回显, 传入当前页列表数据，选中id列表以及$ref获取表格对象，key为设置选中属性值
  setTableCheck(list, selectIds, table, key) {
    list.forEach((item) => {
      if (selectIds.includes(item[key || "uuid"]) && table) {
        table.toggleRowSelection(item);
      }
    });
  },
  /**
   * 表单关键字筛选
   * @param {*} searchData 关键字
   * @param {*} table table列表
   * @param {*} array 只筛选key字段的集合,不传默认筛选查询所有数据
   */
  getFilterTable(searchData, table, array) {
    const search = searchData;
    if (!table || !table.length) {
      return [];
    }
    if (search) {
      return table.filter((data) => {
        return Object.keys(data).some((key) => {
          // 该方法对大小写敏感！所以之前需要toLowerCase()方法将所有查询到内容变为小写。
          if (array) {
            if (array.includes(key)) {
              return String(data[key]).indexOf(search) > -1;
            }
          } else {
            return String(data[key]).indexOf(search) > -1;
          }
        });
      });
    }
    return table;
  },
  /**获取文件名称
   * @param {Object} resInfo 后端返回值
   * @param {String} name 文件名称
   * @param {String} type 类型，用于区分导入和下载
   * @param {Boolean} userHeaderName 是否使用请求头中名称，若为false，则使用自定义名称，需传入name
   */
  getFileName(resInfo, name = "", type = "download", userHeaderName = true) {
    let headerFileName = "";
    //fileInfo 请求头中文件信息
    let fileInfo = resInfo.headers["content-disposition"] || "";
    //获取文件后缀，如'xlsx、doc'
    let strIndex = fileInfo.lastIndexOf(".");
    let headerFileSuffix =
      strIndex > -1 ? fileInfo.substring(strIndex + 1, fileInfo.length) : "";
    //获取请求头中文件名称，不包含文件后缀
    let headerName = fileInfo.substring(0, strIndex);
    let fileNameJson =
      headerName && headerName.match(/filename=(\S*)/)
        ? headerName.match(/filename=(\S*)/)[1]
        : "";
    //获取自定义传入的文件名称
    let nameSuffixIndex = name.lastIndexOf(".");
    let fileName =
      nameSuffixIndex > -1 ? name.substring(0, nameSuffixIndex) : name;
    if (fileNameJson && userHeaderName) {
      headerFileName = fileNameJson
        ? decodeURIComponent(fileNameJson) + "." + headerFileSuffix
        : fileName + "." + headerFileSuffix;
    } else {
      headerFileName = fileName + "." + headerFileSuffix;
    }
    return headerFileName;
  },
  /**
   * 文件下载，传入后端返回文件流及文件名称
   * @param {Object} resInfo 后端返回值
   * @param {String} name 文件名称
   * @param {String} type 类型，用于区分导入和下载
   * @param {Boolean} userHeaderName 是否使用请求头中名称，若为false，则使用自定义名称，需传入name
   */
  fileDownload(resInfo, name = "", type = "download", userHeaderName = true) {
    let blob = resInfo.data;
    let _this = this;
    return new Promise(function (resolve) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (result) => {
        let new_result = result.target.result;
        let index = new_result.lastIndexOf(";base64");
        let resultMsg =
          new_result.indexOf("data:application/json;base64,") > -1
            ? new_result.replace("data:application/json;base64,", "")
            : "";
        if (type == "import" && resultMsg) {
          let msgData = JSON.parse(Base64.decode(resultMsg));
          if (msgData.code === "00000") {
            resolve("success");
          } else if (msgData.code && msgData.code !== "00000") {
            resolve(msgData.msg);
          } else {
            resolve("");
          }
        }
        if (!resultMsg) {
          //判断文件流是否正常
          if (new_result.slice(0, index).indexOf("json") == -1) {
            const url = URL.createObjectURL(new Blob([blob]));
            const a = document.createElement("a");
            a.download = _this.getFileName(resInfo, name, type, userHeaderName);
            a.href = url;
            document.body.appendChild(a);
            a.target = "_blank";
            a.click();
            document.body.removeChild(a);
            if (type == "import") {
              Message.error({
                message: "导入失败，请查看错误文件",
              });
              resolve("");
            } else {
              resolve("success");
            }
          } else {
            let errorInfo = Base64.decode(
              new_result.slice(index + 8, new_result.length)
            );
            Message.error({
              message: errorInfo ? JSON.parse(errorInfo).msg : "下载失败",
            });
            resolve("error");
          }
        } else {
          let msg = Base64.decode(resultMsg) || "";
          let errorData = JSON.parse(msg) || "";
          if (type != "import" && errorData.code != "00000") {
            Message.error({
              message: errorData ? errorData.msg : "请求失败",
            });
          }
        }
      };
    });
  },
  /**清除keepAlive缓存
   * @param fullPath 路由完整路径
   * @param path 路由地址
   */
  clearKeepAlive(keepAlive, fullPath, path) {
    if (keepAlive) {
      const parent = keepAlive.$options.parent;
      let keys = parent.keys;
      let cache = parent.cache;
      for (let key in cache) {
        if (key == fullPath || key.split("?")[0] == path) {
          delete cache[key];
        }
      }
      keys = keys.filter((item) => {
        return item == fullPath || item.split("?")[0] == path;
      });
    }
  },

  /*·----------按钮权限校验·End----------·*/

  /*·----------自定义混入文件参数名称·Start----------·*/
  CustomList,
  // CustomForm
  /*·----------自定义混入文件参数名称·End----------·*/
};
export default utils;
